module.exports = __webpack_public_path__ + "img/flounce_width.1a5510f7.png";